import { render, staticRenderFns } from "./dialog-products-select.vue?vue&type=template&id=07a485ea&"
import script from "./dialog-products-select.vue?vue&type=script&lang=js&"
export * from "./dialog-products-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports